import React from 'react';
import PropTypes from 'prop-types';
import Specification from './specification';
import VehicleSummaryPicker from './vehicleSummaryPicker';
import Modal from '@components/application/modal';
import { useSpecificationContainer } from './useSpecificationContainer';
import { useToggle } from '@lib/hooks';
import VehicleSummary from './vehicleSummary';
import FeaturedSpec from './featuredSpec';

const SpecificationContainer = ({
  allowlist = [],
  independentReview,
  isRealSale,
  specification,
  options = { withToggle: false, showTabs: true },
}) => {
  const {
    additionalSummaryDisplay,
    closeModal,
    displaySummaryPicker,
    handleChange,
    handleSubmit,
    openModal,
    pickerOptions,
    summaryDisplay,
  } = useSpecificationContainer(allowlist, specification);
  const [showSpecification, setShowSpecification] = useToggle();

  const renderSpecification = () => {
    return (
      <>
        <Specification
          featuredSpec={
            <FeaturedSpec
              featuredSpec={specification.featured}
              hotSpec={specification.hotSpec}
              noFeaturedSpecText={specification.noFeaturedSpecText}
              options={{ alignHeaderLeft: options.withToggle }}
            />
          }
          independentReview={independentReview}
          isRealSale={isRealSale}
          showTabs={options.showTabs}
          specification={specification}
          vehicleSummary={
            <VehicleSummary
              displaySummaryPicker={displaySummaryPicker}
              openModal={openModal}
              options={{ alignHeaderLeft: options.withToggle }}
              specificationSummary={specification.summary}
              summaryDisplay={summaryDisplay}
            />
          }
        />
        <Modal hideClose id="vehicleSummary">
          <VehicleSummaryPicker
            closeModal={closeModal}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            options={pickerOptions}
            selected={additionalSummaryDisplay}
          />
        </Modal>
      </>
    );
  };

  return (
    <>
      {options.withToggle ? (
        <>
          <div className="ch-text--center">
            <button
              className={`ch-btn ch-pl--1 ch-pr--4 ch-btn--link ch-mv--4 sm:ch-mt--6 sm:ch-mb--4 toggle-button ${
                showSpecification && 'sm:ch-mb--0 toggle-button--selected'
              }`}
              id="toggleButton"
              onClick={setShowSpecification}
              type="button"
            >
              {showSpecification ? 'Hide vehicle spec' : 'Show vehicle spec'}
            </button>
          </div>
          {showSpecification && renderSpecification()}
        </>
      ) : (
        renderSpecification()
      )}
    </>
  );
};

export default SpecificationContainer;

SpecificationContainer.propTypes = {
  allowlist: PropTypes.array,
  independentReview: PropTypes.object,
  isRealSale: PropTypes.bool,
  options: PropTypes.object,
  specification: PropTypes.object,
};
